export const GRADES = [
  "Chez-Kids 1", "Chez-Kids 2", "Chez-Kids 3",
  "CP1", "CP2", "CE1", "CE2", "CM1", "CM2",
  "7ème Année Fondamentale", "8ème Année Fondamentale", "9ème Année Fondamentale",
  "NS1", "NS2", "NS3", "NS4",
];

// Common abbreviations people type for the full grade names (accent-insensitive).
export const GRADE_ALIASES = {
  "7ème Année Fondamentale": ["7eme af", "7ème af", "7 af", "7af", "7e af", "7eme", "7ème annee"],
  "8ème Année Fondamentale": ["8eme af", "8ème af", "8 af", "8af", "8e af", "8eme", "8ème annee"],
  "9ème Année Fondamentale": ["9eme af", "9ème af", "9 af", "9af", "9e af", "9eme", "9ème annee"],
  "Chez-Kids 1": ["ck1", "chez kids 1", "chezkids1"],
  "Chez-Kids 2": ["ck2", "chez kids 2", "chezkids2"],
  "Chez-Kids 3": ["ck3", "chez kids 3", "chezkids3"],
};

const norm = (s) => (s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, " ").trim();

// Filter the grade list by a query that matches the canonical name OR any known alias.
export function filterGrades(query) {
  const qn = norm(query);
  if (!qn) return GRADES;
  return GRADES.filter((g) => {
    if (norm(g).includes(qn)) return true;
    return (GRADE_ALIASES[g] || []).some((a) => { const an = norm(a); return an.includes(qn) || qn.includes(an); });
  });
}

// Resolve a typed abbreviation to a single canonical grade, or null if not unambiguous.
export function resolveGrade(query) {
  if (GRADES.includes(query)) return query;
  const m = filterGrades(query);
  return m.length === 1 ? m[0] : null;
}
